var mediaQuery = function mediaQuery(breakPoint) {
  return "@media screen and (max-width: ".concat(breakPoint, "px)");
};

export { mediaQuery };
//# sourceMappingURL=index.js.map
